import { Navigate, Route, useLocation, useSearchParams } from 'react-router-dom';
import { Routes } from '@datadog/browser-rum-react/react-router-v6';
import { useCompanyInfo } from '../../utils/hooks/useCompanyInfo';
import { ConstraintView } from './ConstraintView';
import { OptimizationHome } from './OptimizationHome';
import { RunView } from './RunView';
import { StreamingOptimizationPageProps } from './streaming-optimizations-constants';

const LandingRoute = ({ company, streamingType }: StreamingOptimizationPageProps) => {
  const [searchParams] = useSearchParams();
  const legacyRunId = searchParams.get('runId');

  if (legacyRunId) {
    return <Navigate to={`runs/${encodeURIComponent(legacyRunId)}`} replace />;
  }
  return <OptimizationHome company={company} streamingType={streamingType} />;
};

export const StreamingOptimizations = () => {
  const { cid: company } = useCompanyInfo();
  const { pathname } = useLocation();
  const streamingType = pathname.split('/')[2] || 'streaming';
  const basePath = pathname.slice(0, pathname.indexOf('/optimizations') + '/optimizations'.length);
  const pageProps = { company, streamingType };

  return (
    <Routes>
      <Route index element={<LandingRoute {...pageProps} />} />
      <Route path='constraints/:constraintId' element={<ConstraintView {...pageProps} />} />
      <Route path='runs/:runId' element={<RunView {...pageProps} />} />
      <Route path='*' element={<Navigate to={basePath} replace />} />
    </Routes>
  );
};
